import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';

export function RequireAuth() {
  const location = useLocation();
  // Access token only. This used to also require `refreshToken`, which is empty
  // against identity-service: it returns the refresh token as an httpOnly
  // cookie and never puts it in the response body, so the app cannot hold one.
  // The guard therefore rejected every authenticated route after a SUCCESSFUL
  // login — the POS logged in, navigated to /setup, and was bounced straight
  // back to /login with no error shown. The cookie is still what /auth/refresh
  // uses; the browser replays it without the app's involvement.
  const authed = useAuthStore((s) => Boolean(s.accessToken));

  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
